import { useContext } from 'react';

import OverlayStatusContext from './OverlayStatusContext';

const useOverlayStatus = () => {
    return useContext(OverlayStatusContext);
};

export default useOverlayStatus;
